import React from 'react';
import { Spotlight } from '@mantine/spotlight';
import { Search } from 'lucide-react';
import { useOrganizerSpotlightActions } from '../../hooks/useOrganizerSpotlightActions';
import { useNightMode } from '../../contexts/NightModeContext';

/**
 * Global organizer command palette.
 * Actions switch with sidebar context (common / event / venue-event).
 * Opened via Ctrl/Cmd+K or OrganizerSearchBar.
 */
const OrganizerSpotlight: React.FC = () => {
  const actions = useOrganizerSpotlightActions();
  const { isNightMode } = useNightMode();

  return (
    <Spotlight
      actions={actions}
      nothingFound="No organizer actions found..."
      highlightQuery={false}
      limit={30}
      scrollable
      maxHeight={480}
      shortcut={['mod + K']}
      // Sit above organizer sidebar (z-index 9999)
      zIndex={10050}
      overlayProps={{
        backgroundOpacity: 0.55,
        blur: 4,
      }}
      styles={{
        content: {
          background: isNightMode ? 'rgba(14, 14, 14, 0.97)' : 'rgba(255, 255, 255, 0.98)',
          border: isNightMode
            ? '1px solid rgba(238, 63, 124, 0.25)'
            : '1px solid rgba(0, 0, 0, 0.08)',
          borderRadius: 16,
          boxShadow: isNightMode
            ? '0 24px 64px rgba(0, 0, 0, 0.65)'
            : '0 24px 64px rgba(0, 0, 0, 0.15)',
        },
        // Mantine v7 uses "search" (not searchInput) for the query field
        search: {
          color: isNightMode ? '#fff' : '#0f172a',
          borderBottom: isNightMode
            ? '1px solid rgba(255, 255, 255, 0.08)'
            : '1px solid rgba(0, 0, 0, 0.08)',
        },
        action: {
          color: isNightMode ? 'rgba(255,255,255,0.9)' : '#0f172a',
          borderRadius: 10,
        },
        actionsGroup: {
          color: '#EE3F7C',
          fontSize: 11,
          letterSpacing: '0.06em',
          textTransform: 'uppercase' as const,
        },
      }}
      searchProps={{
        leftSection: <Search size={18} style={{ color: '#EE3F7C' }} />,
        placeholder: 'Search events, pages, actions...',
      }}
    />
  );
};

export default OrganizerSpotlight;
